module.exports = __webpack_public_path__ + "1032a1e15f59da86759adf7d3f6b3539.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/category-headers/website.svg
// module id = 1936
// module chunks = 0